import $ from 'jquery';
import {clip} from "../Libraries/Utils";
import {easings} from "../Libraries/smoothy";

/**
 * @param entries {IntersectionObserverEntry[]}
 * @param observer {IntersectionObserver}
 */
function observeCounters(entries, observer) {
    entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.90) {
            return;
        }
        observer.unobserve(entry.target);
        window.setTimeout(() => doCounting(entry.target), 100);
    });
}

/**
 * @param span {HTMLElement}
 */
function doCounting(span) {
    /** @var {number|null} startTime */
    let startTime = null;
    let maxTime = 3000.; // milliseconds

    let maxCount = parseInt(span.dataset.counter);
    let counterType = span.dataset.counterType || null;

    if (isNaN(maxCount)) {
        span.textContent = span.dataset.counter;
        console.warn(
            `Could not parse counter value as integer. Result was NaN: parseInt(${span.dataset.counter})`
        );
        return;
    }

    let formatter;
    if (counterType === 'noFormat') {
        formatter = {format: count => count.toString()};
    } else {
        formatter = new Intl.NumberFormat();
    }

    const counter = (t) => {
        if (startTime === null) {
            startTime = t;
        }

        const delta = t - startTime;
        let progress = clip(delta / maxTime, 0.0, 1.0);
        progress = easings.easeOutCubic(progress);

        let count = parseInt((progress * maxCount).toFixed(0));
        span.textContent = formatter.format(count);

        if (delta < maxTime) {
            window.requestAnimationFrame(counter);
        }
    };

    window.requestAnimationFrame(counter);

}


const observer = new IntersectionObserver(observeCounters, {
    threshold: 0.98,
});

/**
 * Use this function to track counter elements, if the html is
 * added dynamically.
 *
 * @param [context] {HTMLElement} - the root element that countains counter elements.
 */
export function initCounters(context) {
    const root = context || document;

    Array.from(root.querySelectorAll('[data-counter]')).forEach(span => {
        observer.observe(span);
    });

}

$(() => initCounters());
